export enum MedicalHistoryChartFields {
  HealthCheck = 'healthCheck',
  SurgeryCheck = 'surgeryCheck',
  SurgeryDetail = 'surgeryDetail',
  DiseaseCheck = 'diseaseCheck',
  DiseaseName = 'diseaseName',
  DiseaseDrugName = 'diseaseDrugName',
  DiseaseExperience = 'diseaseExperience',
  SmokingCheck = 'smokingCheck',
  SmokingPeriod = 'smokingPeriod',
  AmountOfSmoking = 'amountOfSmoking',
  AlcholCheck = 'alcholCheck',
  AlcholFrequency = 'alcholFrequency',
  AmountOfAlchol = 'amountOfAlchol',
  PregnancyCheck = 'pregnancyCheck',
  PregnancyPeriod = 'pregnancyPeriod',
  AllergyCheck = 'allergyCheck',
  AllergyDetail = 'allergyDetail',
}

export enum HealthStatus {
  Status1 = '아주 건강함',
  Status2 = '양호함',
  Status3 = '조금 약함',
  Status4 = '많이 허약함',
}

export const HealthStatusLabel = {
  [HealthStatus.Status1]: '아주 건강함',
  [HealthStatus.Status2]: '양호함',
  [HealthStatus.Status3]: '조금 약함',
  [HealthStatus.Status4]: '많이 허약함',
} as const;

export enum MedicalHistoryChartRadioBtn {
  Yes = '예',
  No = '아니요',
}

export const MedicalHistoryChartRadioBtnLabel = {
  [MedicalHistoryChartRadioBtn.Yes]: '예',
  [MedicalHistoryChartRadioBtn.No]: '아니요',
} as const;

export const HealthStatusList = [
  {
    label: HealthStatusLabel[HealthStatus.Status1],
    value: HealthStatus.Status1,
  },
  {
    label: HealthStatusLabel[HealthStatus.Status2],
    value: HealthStatus.Status2,
  },
  {
    label: HealthStatusLabel[HealthStatus.Status3],
    value: HealthStatus.Status3,
  },
  {
    label: HealthStatusLabel[HealthStatus.Status4],
    value: HealthStatus.Status4,
  },
];

export enum DiseaseName {
  심혈관질환 = '심혈관질환',
  고혈압 = '고혈압',
  저혈압 = '저혈압',
  부정맥 = '부정맥',
  심혈관질환_선천성심장질환 = '심혈관질환_선천성심장질환',
  심장질환_선천성심장질환 = '심장질환_선천성심장질환',
  울혈성신부전 = '울혈성신부전',
  심박동조율기 = '심박동조율기',
  당뇨병 = '당뇨병',
  갑상선질환 = '갑상선질환',
  항진증 = '항진증',
  부전증 = '부전증',
  호흡기질환 = '호흡기질환',
  천식 = '천식',
  기관지염 = '기관지염',
  만성폐색성폐질환 = '만성폐색성폐질환',
  심장질환 = '심장질환',
  인공심장판막 = '인공심장판막',
  감염성심내막염 = '감염성심내막염',
  심장이식 = '심장이식',
  면역질환 = '면역질환',
  면역질환_에이즈 = '면역질환_에이즈',
  감염성질환_에이즈 = '감염성질환_에이즈',
  백혈병 = '백혈병',
  암 = '암',
  화학요법약복용 = '화학요법약복용',
  면역억제제복용 = '면역억제제복용',
  출혈질환 = '출혈질환',
  빈혈 = '빈혈',
  혈우병 = '혈우병',
  항응고제복용 = '항응고제복용',
  신경계질환 = '신경계질환',
  뇌전증 = '뇌전증',
  뇌졸중 = '뇌졸중',
  간질환 = '간질환',
  황달 = '황달',
  간질환_A형간염 = '간질환_A형간염',
  간질환_B형간염 = '간질환_B형간염',
  감염성질환_A형간염 = '감염성질환_A형간염',
  감염성질환_B형간염 = '감염성질환_B형간염',
  C형간염 = 'C형간염',
  관절질환 = '관절질환',
  관절염 = '관절염',
  류마티즘 = '류마티즘',
  감염성질환 = '감염성질환',
  결핵 = '결핵',
  포진 = '포진',
  유행성감기 = '유행성감기',
  신장질환 = '신장질환',
  신장이식 = '신장이식',
  성병 = '성병',
  매독 = '매독',
  임질 = '임질',
  클라미디아 = '클라미디아',
  기타 = '기타',
}

export const DiseaseLabel = {
  [DiseaseName.심혈관질환]: '심혈관질환',
  [DiseaseName.고혈압]: '고혈압',
  [DiseaseName.저혈압]: '저혈압',
  [DiseaseName.부정맥]: '부정맥',
  [DiseaseName.심혈관질환_선천성심장질환]: '선천성 심장질환',
  [DiseaseName.심장질환_선천성심장질환]: '선천성 심장질환',
  [DiseaseName.울혈성신부전]: '울혈성 신부전',
  [DiseaseName.심박동조율기]: '심박동 조율기',
  [DiseaseName.당뇨병]: '당뇨병',
  [DiseaseName.갑상선질환]: '갑상선질환',
  [DiseaseName.항진증]: '항진증',
  [DiseaseName.부전증]: '부전증',
  [DiseaseName.호흡기질환]: '호흡기질환',
  [DiseaseName.천식]: '천식',
  [DiseaseName.기관지염]: '기관지염',
  [DiseaseName.만성폐색성폐질환]: '만성폐색성폐질환',
  [DiseaseName.심장질환]: '심장질환',
  [DiseaseName.인공심장판막]: '인공심장판막',
  [DiseaseName.감염성심내막염]: '감염성 심내막염',
  [DiseaseName.심장이식]: '심장이식',
  [DiseaseName.면역질환]: '면역질환',
  [DiseaseName.면역질환_에이즈]: '에이즈(HIV)',
  [DiseaseName.감염성질환_에이즈]: '에이즈(HIV)',
  [DiseaseName.백혈병]: '백혈병',
  [DiseaseName.암]: '암',
  [DiseaseName.화학요법약복용]: '화학요법약 복용(암환자)',
  [DiseaseName.면역억제제복용]: '면역억제제 복용',
  [DiseaseName.출혈질환]: '출혈질환',
  [DiseaseName.빈혈]: '빈혈',
  [DiseaseName.혈우병]: '혈우병',
  [DiseaseName.항응고제복용]: '항응고제 복용',
  [DiseaseName.신경계질환]: '신경계질환',
  [DiseaseName.뇌전증]: '뇌전증',
  [DiseaseName.뇌졸중]: '뇌졸중(뇌중풍)',
  [DiseaseName.간질환]: '간질환',
  [DiseaseName.황달]: '황달',
  [DiseaseName.간질환_A형간염]: 'A형간염',
  [DiseaseName.간질환_B형간염]: 'B형간염',
  [DiseaseName.감염성질환_A형간염]: 'A형간염',
  [DiseaseName.감염성질환_B형간염]: 'B형간염',
  [DiseaseName.C형간염]: 'C형간염',
  [DiseaseName.관절질환]: '관절질환',
  [DiseaseName.관절염]: '관절염',
  [DiseaseName.류마티즘]: '류마티즘',
  [DiseaseName.감염성질환]: '감염성질환',
  [DiseaseName.결핵]: '결핵',
  [DiseaseName.포진]: '포진(헤르페스)',
  [DiseaseName.유행성감기]: '유행성감기',
  [DiseaseName.신장질환]: '신장질환',
  [DiseaseName.신장이식]: '신장이식',
  [DiseaseName.성병]: '성병',
  [DiseaseName.매독]: '매독',
  [DiseaseName.임질]: '임질',
  [DiseaseName.클라미디아]: '클라미디아',
  [DiseaseName.기타]: '기타',
} as const;

export enum PregnancyRadioBtn {
  Yes = '예',
  No = '아니요',
  Etc = '기타',
}

export const PregnancyRadioBtnLabel = {
  [PregnancyRadioBtn.Yes]: '예',
  [PregnancyRadioBtn.No]: '아니요',
  [PregnancyRadioBtn.Etc]: '기타 (수유 중 / 피임약 복용 / 호르몬대치요법 등)',
};

export enum AllergyStatus {
  Allergy1 = '복용 약',
  Allergy2 = '치과 마취제',
  Allergy3 = '라텍스',
  Allergy4 = '금속',
  Allergy5 = '기타',
}

export const AllergyStatusLabel = {
  [AllergyStatus.Allergy1]:
    '복용 약 [아스피린 / 페니실린 또는 다른 항생제 / 설파제 / 안정제 / 수면제 / 요오드 등]',
  [AllergyStatus.Allergy2]: '치과 마취제',
  [AllergyStatus.Allergy3]: '라텍스',
  [AllergyStatus.Allergy4]: '금속 [은/수은]',
  [AllergyStatus.Allergy5]: '기타 [동물 / 음식 / 건초열 (꽃가루로 인한)]',
} as const;

export const MedicalHistoryChartFormDefaultValues = {
  [MedicalHistoryChartFields.HealthCheck]: undefined,
  [MedicalHistoryChartFields.SurgeryCheck]: undefined,
  [MedicalHistoryChartFields.SurgeryDetail]: '',
  [MedicalHistoryChartFields.DiseaseCheck]: undefined,
  [MedicalHistoryChartFields.DiseaseName]: '',
  [MedicalHistoryChartFields.DiseaseDrugName]: '',
  [MedicalHistoryChartFields.DiseaseExperience]: [],
  [MedicalHistoryChartFields.SmokingCheck]: undefined,
  [MedicalHistoryChartFields.SmokingPeriod]: undefined,
  [MedicalHistoryChartFields.AmountOfSmoking]: undefined,
  [MedicalHistoryChartFields.AlcholCheck]: undefined,
  [MedicalHistoryChartFields.AlcholFrequency]: undefined,
  [MedicalHistoryChartFields.AmountOfAlchol]: '',
  [MedicalHistoryChartFields.PregnancyCheck]: undefined,
  [MedicalHistoryChartFields.PregnancyPeriod]: undefined,
  [MedicalHistoryChartFields.AllergyCheck]: [],
  [MedicalHistoryChartFields.AllergyDetail]: '',
};
